export default function cancelable(originalPromise) {
  let isCancelled = false;
  const newPromise = new Promise(function (resolve, reject) {
    originalPromise.then(
      (val) => {
        if (!isCancelled) {
          resolve(val);
        }
      },
      (err) => {
        if (!isCancelled) {
          reject(err);
        }
      },
    );
  });
  newPromise.cancel = function () {
    isCancelled = true;
  };
  return newPromise;
}
